import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Tutor {
  id: string;
  token: string;
  name: string;
  lastName: string;
  platformUser: string;
  email: string;
  roles: string[];
  tutorType: string;
  commercialNetwork?: string | null;
  company: string;
  companyName?: string | null;
}

export interface TutorState {
  isAuthenticated: boolean;
  tutor: Tutor | null;
  loading: boolean;
  error: string | null;
}

export const initialState: TutorState = {
  isAuthenticated: false,
  tutor: null,
  loading: false,
  error: null,
};

const tutorSlice = createSlice({
  name: 'tutor',
  initialState,
  reducers: {
    tutorLogin: (state: TutorState, action: PayloadAction<TutorState>) => {
      state = {
        ...action.payload
      }
      return state;
    },
    tutorLogout: (state) => {
      state.isAuthenticated = false;
      state.tutor = null;
      return state;
    },
  }
});

export const loginThunk = createAsyncThunk('tutor/login', async (tutorData: any, { dispatch }) => {
  dispatch(tutorLogin(tutorData));
});

export const logoutThunk = createAsyncThunk('tutor/logout', async (_, { dispatch }) => {
  dispatch(tutorLogout());
});

export const { tutorLogout, tutorLogin } = tutorSlice.actions;

export default tutorSlice.reducer;